"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pkceChallengeFromVerifier = exports.generateRandomString = exports.base64UrlEncode = void 0;
/**
 * Generates a random string used as the code verifier.
 *
 * @returns {string}
 */
const generateRandomString = () => {
  const array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, number => `0${number.toString(16)}`.substr(-2)).join('');
};

/**
 * Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
 * btoa accepts chars only within ascii 0-255 and base64 encodes them.
 * Then convert the base64 encoded to base64url encoded (replace + with -, replace / with _, trim trailing =).
 *
 * @param {string} str The string you want to encode
 * @returns {string}
 */
exports.generateRandomString = generateRandomString;
const base64UrlEncode = str => btoa(String.fromCharCode.apply(null, new Uint8Array(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

/**
 * Calculate the SHA256 hash of the input text.
 * Returns a promise that resolves to an ArrayBuffer.
 *
 * @param {ArrayBuffer} plain The array buffer you want to encode.
 * @returns {Promise<string>}
 */
exports.base64UrlEncode = base64UrlEncode;
const sha256 = plain => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
};

/**
 * Return the base64-urlencoded sha256 hash for the PKCE challenge.
 *
 * @param {string} codeVerifier The randomly generated string you are using as a code verifier.
 * @returns {string}
 */
const pkceChallengeFromVerifier = codeVerifier => sha256(codeVerifier).then(hashed => base64UrlEncode(hashed));
exports.pkceChallengeFromVerifier = pkceChallengeFromVerifier;